import { Component } from "@angular/core";
import { Location } from "@angular/common";

@Component({
    selector: "app-errors",
    templateUrl: "./errors.component.html",
    styleUrls: ["./errors.component.scss"],
})
export class ErrorsComponent {
    constructor(private location: Location) {}

    loadBack() {
        this.location.back();
    }
}
